import { useParams, useSearchParams } from "react-router-dom";
import { ShieldCheck, ShieldAlert } from "lucide-react";
import { useEffect, useState } from "react";
import axios from "axios";
import { API, inr } from "../lib/api";

export default function VerifyInvoice() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/public/invoices/${id}/verify`, { params: { h: sp.get("h") || "" } }).then((r) => setD(r.data)).catch(() => setD({ valid: false })); }, [id, sp]);
  return (
    <div className="min-h-screen bg-[#0B1017] text-white grid place-items-center p-6">
      <div className="c-surface p-6 max-w-md w-full grid gap-3" data-testid="verify-invoice">
        {!d ? <p className="text-sm text-slate-400">Checking…</p> : d.valid ? <>
          <div className="flex items-center gap-2 text-emerald-400 font-semibold" data-testid="verify-valid"><ShieldCheck size={20} />Genuine invoice. Figures unchanged.</div>
          {[["Invoice", d.number], ["Contractor", d.vendor_name], ["Billed to", d.employer_name], ["Period", d.month], ["Date", d.invoice_date], ["Taxable value", inr(d.taxable)], ["Total", inr(d.total)], ["Status", d.status]].map(([k, v]) =>
            <div key={k} className="flex justify-between text-sm border-t border-[#1F2A3E] pt-2"><span className="text-slate-400">{k}</span><span className="font-mono">{v}</span></div>)}
          <p className="text-xs text-slate-500">If the printed copy shows different figures, it has been altered.</p></>
          : <div className="flex items-center gap-2 text-rose-400 font-semibold" data-testid="verify-invalid"><ShieldAlert size={20} />This invoice could not be verified. Don't accept it.</div>}
        <p className="text-[11px] text-slate-600">Comply369 production-linked invoicing</p>
      </div>
    </div>);
}
